import { Directive, Input, OnDestroy, OnInit } from '@angular/core';
import { ActivationStart, Router, RouterOutlet } from '@angular/router';
import { filter, takeWhile, tap } from 'rxjs/operators';

@Directive({
  selector: '[outletActivationManager]',
  standalone: false,
})
export class OutletActivationManagerDirective implements OnInit, OnDestroy {
  @Input('outletActivationManager') outlet!: RouterOutlet;
  @Input() name = '';
  alive = true;

  constructor(private router: Router) {}

  ngOnInit() {
    this.router.events
      .pipe(
        takeWhile(() => this.alive),
        filter(
          (event) =>
            event instanceof ActivationStart &&
            event.snapshot.outlet === this.name &&
            this.outlet.isActivated
        ),
        tap((event) => this.outlet.deactivate())
      )
      .subscribe();
  }

  ngOnDestroy() {
    this.alive = false;
  }
}
